import { useMemo } from 'react';
import { useSERPActions } from '~/core/state/actions/SERPActionsContext';
import { useSERPState } from '~/core/state/SERPStateContext';
import { SetSelectedTab } from '~/core/useSearchState';
import { TabResult, useTabsResults } from './useTabResults';

export interface IUseSelectedTab {
    activeTab: TabResult | undefined;
    setActiveTab: SetSelectedTab;
}

/**
 * This hook is a simplification and wrapper around useSERPState hook.
 * It exports the selected tab but gives it more data to work with.
 * So we can use it more clearly without having to lookup all the data ourselves all the time.
 * @returns selected tab object and method to change it
 */
export const useSelectedTab = (): IUseSelectedTab => {
    const { selectedTab } = useSERPState();
    const { setSelectedTab } = useSERPActions();
    const { results } = useTabsResults();

    const activeTab = useMemo(
        () => results.find((tab) => tab.result.querySetIdentifier === selectedTab),
        [selectedTab, results]
    );

    return {
        activeTab,
        setActiveTab: setSelectedTab,
    };
};
